import PropTypes from "prop-types";

import API_Calls_UsersTable from "@/api/calls/API_Calls_UsersTable";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import { canManageAllUsers } from "@/utils/permissionsHandler";

function UserModalServices(
  dataToAlter,
  updateTable,
  cleanUpModal,
  name,
  email,
  managementToken,
  chosenAffiliate,
  chosenRole,
  user,
  setNotification
) {
  const {
    editUser,
    deleteUser,
    inviteUserAffiliateAdmin,
    inviteUserSystemAdmin,
  } = API_Calls_UsersTable();
  const { workflow } = useUpdateDataContext();

  const deleteUserHandler = async (e) => {
    e.preventDefault();
    const { affiliate_id, user_id } = dataToAlter;

    const result = await deleteUser(affiliate_id, user_id, managementToken);
    if (result.status === 204) {
      setNotification({
        message: "User deleted!",
        severity: "info",
        duration: 3000,
      });
      updateTable({ user_id }, "delete");
      cleanUpModal();
    } else {
      setNotification({
        message: "Apologies! There was an issue deleting the user!",
        severity: "error",
        duration: null,
      });
      cleanUpModal();
    }
  };

  const inviteUserHandler = async (e) => {
    e.preventDefault();
    let result;

    if (canManageAllUsers(user)) {
      result = await inviteUserSystemAdmin(
        chosenAffiliate.id,
        name,
        email,
        chosenRole,
        managementToken,
        workflow
      );
    } else {
      result = await inviteUserAffiliateAdmin(
        user.org_id,
        name,
        email,
        managementToken
      );
    }

    if (result.status === 201) {
      cleanUpModal();
      setNotification({
        message: result.data,
        severity: "success",
        duration: 3000,
      });
    } else {
      cleanUpModal();
      setNotification({
        message: "Apologies! There was an issue sending the invitation!",
        severity: "error",
        duration: null,
      });
    }
  };

  const editUserHandler = async (e) => {
    e.preventDefault();
    let obj = {};
    if (name !== dataToAlter.name) {
      obj = Object.assign(obj, { name });
    }
    if (email !== dataToAlter.email) {
      obj = Object.assign(obj, { email });
    }
    const result = await editUser(dataToAlter.user_id, obj, managementToken);

    if (result.status === 200) {
      setNotification({
        message: "User updated!",
        severity: "success",
        duration: 3000,
      });
      const editedUserObject = {
        name,
        email,
        user_id: dataToAlter.user_id,
        local: dataToAlter.local,
        affiliate_id: dataToAlter.affiliate_id,
        affiliate_name: dataToAlter.local,
        role: dataToAlter.role,
      };
      updateTable(editedUserObject, "edit");
      cleanUpModal();
    } else {
      setNotification({
        message: "Apologies! There was an issue updating the user!",
        severity: "error",
        duration: null,
      });
      cleanUpModal();
    }
  };

  return { deleteUserHandler, inviteUserHandler, editUserHandler };
}

UserModalServices.propTypes = {
  dataToAlter: PropTypes.object,
  setFeedback: PropTypes.func,
  updateTable: PropTypes.func,
  cleanUpModal: PropTypes.func,
  name: PropTypes.string,
  email: PropTypes.string,
  token: PropTypes.string,
  managementToken: PropTypes.string,
  chosenAffiliate: PropTypes.object,
  chosenRole: PropTypes.string,
  user: PropTypes.object,
};
export default UserModalServices;
